module.exports = __webpack_public_path__ + "img/Price-List.1659c382.png";